import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UrlManager} from '@ccp/lib/url-manager';
import {environment} from '@ccp/environments/global/environment';
import {tap} from 'rxjs/operators';
import {Views} from '@ccp/config/views';
import {Logger} from '@ccp/lib/logger';
import {LocaleContextService} from '@ccp/services/app-context/locale-context.service';

/** Inject With Credentials into the request */
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(public localeContextService: LocaleContextService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // exclude check phone number
    if (!this.isCheckPhoneUrl(req.url)) {
      // Check is app is loaded, add language and country to all http calls.
      if (this.localeContextService?.currentCountry$() && this.localeContextService?.currentLang$()) {
        const url = UrlManager.setParams(
          {
            country: this.localeContextService.currentCountry$().isoCode,
            language: this.localeContextService.currentLang$().isoCode,
          },
          req.url,
        );

        return next.handle(req.clone({url})).pipe(
          tap({
            next: () => Logger.debug(`HttpInterceptor ${req.method} "${req.urlWithParams}" succeeded`),
            error: this.handleUnauthorizedRequest(),
          }),
        );
      }
    }

    return next.handle(req.clone(req)).pipe(
      tap({
        next: () => Logger.debug(`HttpInterceptor ${req.method} "${req.urlWithParams}" succeeded`),
        error: this.handleUnauthorizedRequest(),
      }),
    );
  }

  private handleUnauthorizedRequest() {
    const authorizedPaths = ['/connected', '/login', '/customer/customer', 'customer/password', environment.api.endPoints.tokenVerify];
    return (error: HttpErrorResponse) => {
      const url = error.url.split('?')[0];
      if (error instanceof HttpErrorResponse && error.status === 401 && !authorizedPaths.some((path) => url.endsWith(path))) {
        // router.navigate([Views.userLogin.path]);   // Won't work!!! la solution de navigate, redirige vers la page serial, mais ne rafraichit pas le contexte...
        Logger.warn(`HttpInterceptor: user not connected ${error.url} "${error.status}"`, {
          error: error,
          http: {
            url: error.url,
            status: error.statusText,
          },
        });
        window.location.href = Views.userLogin.path;
      } else {
        Logger.error(`HttpInterceptor ${error.url} "${error.status}"`, {
          error: error,
          http: {
            url: error.url,
            status: error.status?.toString(),
          },
        });
      }
    };
  }

  private isCheckPhoneUrl(url: string): boolean {
    const preprod = 'text-tools-phone/v1/number'; // literal, to handle china preprod
    const api = environment.api.endPoints.checkPhoneNumber;
    return url.includes(preprod) || url.includes(api);
  }
}
